/**
 * Yazı tipi seçenekleri — kullanıcının tanıdığı adlarla (Arial, Verdana, Georgia…).
 *
 * Bilerek yalnızca SİSTEMDE BULUNAN aileler sunuluyor; web fontu indirilmiyor. Octo
 * kurulumlarının bir kısmı internete kapalı ağlarda çalışıyor ve dışarıdan font çekmek
 * orada ya sessizce başarısız olur ya da ilk boyamayı geciktirir.
 *
 * Her seçenek kendi yedek zinciriyle veriliyor: aile o makinede yoksa yazı bozulmaz,
 * benzer bir aileye düşer. Örneğin Segoe UI yalnızca Windows'ta, Helvetica pratikte
 * yalnızca macOS'ta var.
 */

export const FONT_CHOICES = {
  /** Uygulamanın kendi yazı tipi. */
  default: "'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  /** İşletim sisteminin arayüz fontu — makineye en tanıdık görünüm. */
  system: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",

  arial: 'Arial, Helvetica, sans-serif',
  helvetica: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  verdana: 'Verdana, Geneva, DejaVu Sans, sans-serif',
  tahoma: 'Tahoma, Verdana, Geneva, sans-serif',
  trebuchet: "'Trebuchet MS', 'Lucida Grande', Tahoma, sans-serif",
  segoe: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  roboto: "Roboto, 'Helvetica Neue', Arial, sans-serif",

  georgia: "Georgia, 'Times New Roman', Times, serif",
  times: "'Times New Roman', Times, 'Liberation Serif', serif",

  consolas: "Consolas, 'Courier New', ui-monospace, monospace",
  courier: "'Courier New', Courier, ui-monospace, monospace",
} as const;

export type FontChoice = keyof typeof FONT_CHOICES;
export const FONT_CHOICE_KEYS = Object.keys(FONT_CHOICES) as FontChoice[];

/**
 * Listede gösterilecek ad. Font adları çevrilmez (Arial her dilde Arial); yalnızca
 * ilk iki seçenek anlam taşıdığı için çeviriden gelir.
 */
export const FONT_LABELS: Record<FontChoice, string | null> = {
  default: null,
  system: null,
  arial: 'Arial',
  helvetica: 'Helvetica',
  verdana: 'Verdana',
  tahoma: 'Tahoma',
  trebuchet: 'Trebuchet MS',
  segoe: 'Segoe UI',
  roboto: 'Roboto',
  georgia: 'Georgia',
  times: 'Times New Roman',
  consolas: 'Consolas',
  courier: 'Courier New',
};

export function fontStackOf(choice: FontChoice | undefined): string {
  return FONT_CHOICES[choice ?? 'default'] ?? FONT_CHOICES.default;
}
